var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllCoinshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247,
    height: 72.333,
    viewBox: "0 0 247 72.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ill-coinshop",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 3.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117107",
    "data-name": "Path 117107",
    d: "M196.94,14.853c22.9-7.149,45.691-12.159,50.786.262,9.566,23.322-11.85,14.771.1,35.641,14.715,25.692-16.318,29.68-43.219,20.822-6.752-2.224-14.513-.01-20.749,0-11.259.017-88.815,0-114.008,0-12.614,0-12.614-9.276-40.592,0C12.8,77.034,5.51,65.243,4.656,57.562s13.841-5.64,11.83-15.926C14.328,30.594-4.469,21.052,10.517,13.367S53.8,4.25,73.172,17.02,107.2,2.745,136.913,7.382C166.174,11.949,178.436,20.629,196.94,14.853Z",
    transform: "translate(-4.62 -6.841)",
    fill: "#bad3f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(64.48 63.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117108",
    "data-name": "Path 117108",
    d: "M205.993,93.236H90.92a.754.754,0,0,1,0-1.508H205.993a.754.754,0,0,1,0,1.507Z",
    transform: "translate(-90.166 -91.728)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(79.779 1.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    d: "M5.123,0H56.583a5.123,5.123,0,0,1,5.123,5.123v7.045a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5.123A5.123,5.123,0,0,1,5.123,0Z",
    transform: "translate(12.139 0.754)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117109",
    "data-name": "Path 117109",
    d: "M188.273,10.153a3.846,3.846,0,0,0-1.155-2.75L126.567,18.459h61.706Z",
    transform: "translate(-114.429 -5.538)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(1.64 12.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 72.18,
    height: 42.486,
    transform: "translate(5.261 12.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117110",
    "data-name": "Path 117110",
    d: "M119.62,48.7h0a9.309,9.309,0,0,0,4.507-1.115,9.67,9.67,0,0,0,9.015,0,9.666,9.666,0,0,0,9.03-.009,9.667,9.667,0,0,0,9.031.009,9.67,9.67,0,0,0,9.015,0,9.667,9.667,0,0,0,9.013,0,9.67,9.67,0,0,0,9.015,0,9.666,9.666,0,0,0,9.03-.009A9.312,9.312,0,0,0,191.8,48.7h0V39.705H119.62Z",
    transform: "translate(-114.358 -25.66)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117111",
    "data-name": "Path 117111",
    d: "M191.307,37.213V79.7H119.126V37.213h72.181m0-1.508H119.126a1.508,1.508,0,0,0-1.507,1.508V79.7a1.508,1.508,0,0,0,1.507,1.507h72.181a1.508,1.508,0,0,0,1.508-1.507V37.213a1.508,1.508,0,0,0-1.508-1.508Z",
    transform: "translate(-113.866 -24.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117112",
    "data-name": "Path 117112",
    d: "M184.66,22.071H123.814L113.64,33.855v3.367c0,1.859,2.018,3.366,4.507,3.366s4.507-1.507,4.507-3.366c0,1.859,2.018,3.366,4.507,3.366s4.507-1.507,4.507-3.366c0,1.859,2.018,3.366,4.507,3.366s4.507-1.507,4.507-3.366l.033-.019v.019c0,1.859,2.018,3.366,4.507,3.366s4.507-1.507,4.507-3.366c0,1.859,2.019,3.366,4.507,3.366s4.507-1.507,4.507-3.366c0,1.859,2.018,3.366,4.507,3.366s4.507-1.507,4.507-3.366c0,1.859,2.018,3.366,4.507,3.366s4.507-1.507,4.507-3.366c0,1.859,2.018,3.366,4.507,3.366s4.507-1.507,4.507-3.366h.033c0,1.859,2.018,3.366,4.507,3.366s4.507-1.507,4.507-3.366V33.855Z",
    transform: "translate(-112.886 -21.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117113",
    "data-name": "Path 117113",
    d: "M158.575,37.705h-9.014v3.367c0,1.859,2.018,3.366,4.507,3.366h0c2.489,0,4.507-1.507,4.507-3.366Z",
    transform: "translate(-121.731 -25.167)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117114",
    "data-name": "Path 117114",
    d: "M134.613,37.705H125.6v3.367c0,1.859,2.018,3.366,4.507,3.366h0c2.489,0,4.507-1.507,4.507-3.366Z",
    transform: "translate(-115.831 -25.167)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117115",
    "data-name": "Path 117115",
    d: "M206.412,37.705H197.4v3.367c0,1.859,2.018,3.366,4.507,3.366h0c2.49,0,4.507-1.507,4.507-3.366Z",
    transform: "translate(-133.511 -25.167)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117116",
    "data-name": "Path 117116",
    d: "M182.494,37.705H173.48v3.367c0,1.859,2.018,3.366,4.507,3.366h0c2.49,0,4.507-1.507,4.507-3.366Z",
    transform: "translate(-127.621 -25.167)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0.754 0.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117117",
    "data-name": "Path 117117",
    d: "M170.535,33.855H161.52l1.127-11.784h6.761Z",
    transform: "translate(-125.43 -22.071)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117118",
    "data-name": "Path 117118",
    d: "M193.382,33.855h-9.014l-3.413-11.784h6.761Z",
    transform: "translate(-130.216 -22.071)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117119",
    "data-name": "Path 117119",
    d: "M215.828,33.855h-9.014l-7.921-11.784h6.761Z",
    transform: "translate(-134.633 -22.071)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117120",
    "data-name": "Path 117120",
    d: "M137.558,33.855h9.014l3.413-11.784h-6.761Z",
    transform: "translate(-119.53 -22.071)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117121",
    "data-name": "Path 117121",
    d: "M113.64,33.855h9.014l7.921-11.784h-6.761Z",
    transform: "translate(-113.64 -22.071)",
    fill: "#1890ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117122",
    "data-name": "Path 117122",
    d: "M170.535,37.705H161.52v3.367c0,1.859,2.019,3.366,4.507,3.366h0c2.489,0,4.507-1.507,4.507-3.366Z",
    transform: "translate(-124.676 -25.167)",
    fill: "#0980d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117123",
    "data-name": "Path 117123",
    d: "M146.572,37.705h-9.014v3.367c0,1.859,2.018,3.366,4.507,3.366h0c2.489,0,4.507-1.507,4.507-3.366Z",
    transform: "translate(-118.776 -25.167)",
    fill: "#0980d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117124",
    "data-name": "Path 117124",
    d: "M122.654,37.705H113.64v3.367c0,1.859,2.018,3.366,4.507,3.366h0c2.49,0,4.507-1.507,4.507-3.366Z",
    transform: "translate(-112.886 -25.167)",
    fill: "#0980d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117125",
    "data-name": "Path 117125",
    d: "M218.415,37.705H209.4v3.367c0,1.859,2.018,3.366,4.507,3.366h0c2.489,0,4.507-1.507,4.507-3.366Z",
    transform: "translate(-136.467 -25.167)",
    fill: "#0980d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117126",
    "data-name": "Path 117126",
    d: "M194.453,37.705h-9.014v3.367c0,1.859,2.018,3.366,4.507,3.366h0c2.49,0,4.507-1.507,4.507-3.366Z",
    transform: "translate(-130.566 -25.167)",
    fill: "#0980d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117127",
    "data-name": "Path 117127",
    d: "M170.288,34.363h-9.013a.754.754,0,0,1-.751-.825l1.128-11.784a.753.753,0,0,1,.75-.682h6.76a.753.753,0,0,1,.75.682l1.128,11.784a.754.754,0,0,1-.751.825ZM162.1,32.855h7.355l-.983-10.277h-5.389Z",
    transform: "translate(-124.43 -21.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117128",
    "data-name": "Path 117128",
    d: "M181.879,34.363h-9.014a.754.754,0,0,1-.75-.682L170.988,21.9a.754.754,0,0,1,.75-.826H178.5a.754.754,0,0,1,.724.546L182.6,33.4a.753.753,0,0,1-.724.962Zm-8.328-1.507h7.328l-2.948-10.277h-5.363Z",
    transform: "translate(-127.007 -21.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117129",
    "data-name": "Path 117129",
    d: "M193.135,34.363h-9.014a.755.755,0,0,1-.724-.544l-3.413-11.783a.754.754,0,0,1,.724-.964h6.761a.754.754,0,0,1,.679.427l5.667,11.783a.754.754,0,0,1-.68,1.081Zm-8.448-1.507h7.25l-4.942-10.277h-5.284Z",
    transform: "translate(-129.215 -21.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117130",
    "data-name": "Path 117130",
    d: "M204.359,34.363h-9.015a.754.754,0,0,1-.679-.427L189,22.152a.754.754,0,0,1,.68-1.081h6.76a.755.755,0,0,1,.626.333l7.92,11.784a.754.754,0,0,1-.626,1.174Zm-8.541-1.507h7.126l-6.908-10.277h-5.159Z",
    transform: "translate(-131.424 -21.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117131",
    "data-name": "Path 117131",
    d: "M215.581,34.363h-9.014a.753.753,0,0,1-.626-.333l-7.92-11.784a.754.754,0,0,1,.626-1.174h6.76a.753.753,0,0,1,.571.262l10.174,11.784a.753.753,0,0,1-.571,1.246Zm-8.612-1.507h6.965l-8.873-10.277h-5Z",
    transform: "translate(-133.633 -21.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117132",
    "data-name": "Path 117132",
    d: "M158.33,34.363h-9.014a.753.753,0,0,1-.724-.962l3.38-11.784a.754.754,0,0,1,.724-.546h6.761a.754.754,0,0,1,.75.826L159.08,33.68A.754.754,0,0,1,158.33,34.363Zm-8.014-1.507h7.328l.983-10.277h-5.363Z",
    transform: "translate(-121.485 -21.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117133",
    "data-name": "Path 117133",
    d: "M146.327,34.363h-9.014a.754.754,0,0,1-.68-1.081L142.3,21.5a.754.754,0,0,1,.679-.427h6.761a.754.754,0,0,1,.724.964l-3.413,11.783A.755.755,0,0,1,146.327,34.363Zm-7.816-1.507h7.25l2.976-10.277h-5.284Z",
    transform: "translate(-118.529 -21.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117134",
    "data-name": "Path 117134",
    d: "M134.368,34.363h-9.015a.754.754,0,0,1-.626-1.174l7.92-11.784a.755.755,0,0,1,.626-.333h6.76a.754.754,0,0,1,.68,1.081l-5.667,11.784A.754.754,0,0,1,134.368,34.363Zm-7.6-1.507h7.126l4.941-10.277h-5.159Z",
    transform: "translate(-115.584 -21.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117135",
    "data-name": "Path 117135",
    d: "M122.408,34.363h-9.014a.753.753,0,0,1-.571-1.246L123,21.333a.753.753,0,0,1,.571-.262h6.76a.754.754,0,0,1,.626,1.174l-7.921,11.784A.753.753,0,0,1,122.408,34.363Zm-7.368-1.507h6.965l6.908-10.277h-5Z",
    transform: "translate(-112.639 -21.071)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(0.001 11.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117136",
    "data-name": "Path 117136",
    d: "M165.781,44.946c-2.9,0-5.26-1.848-5.26-4.121V37.459a.754.754,0,0,1,.754-.754h9.013a.754.754,0,0,1,.754.754v3.366C171.042,43.1,168.683,44.946,165.781,44.946Zm-3.753-6.733v2.612c0,1.417,1.719,2.613,3.753,2.613s3.753-1.2,3.753-2.613V38.213Z",
    transform: "translate(-124.431 -36.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117137",
    "data-name": "Path 117137",
    d: "M153.822,44.946c-2.9,0-5.26-1.848-5.26-4.121V37.459a.754.754,0,0,1,.754-.754h9.014a.754.754,0,0,1,.754.754v3.366C159.084,43.1,156.724,44.946,153.822,44.946Zm-3.753-6.733v2.612c0,1.417,1.719,2.613,3.753,2.613s3.754-1.2,3.754-2.613V38.213Z",
    transform: "translate(-121.486 -36.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117138",
    "data-name": "Path 117138",
    d: "M141.819,44.946c-2.9,0-5.26-1.848-5.26-4.121V37.459a.754.754,0,0,1,.754-.754h9.014a.754.754,0,0,1,.754.754v3.366C147.081,43.1,144.721,44.946,141.819,44.946Zm-3.753-6.733v2.612c0,1.417,1.719,2.613,3.753,2.613s3.754-1.2,3.754-2.613V38.213Z",
    transform: "translate(-118.53 -36.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117139",
    "data-name": "Path 117139",
    d: "M129.859,44.946c-2.9,0-5.26-1.848-5.26-4.121V37.459a.754.754,0,0,1,.754-.754h9.015a.754.754,0,0,1,.754.754v3.366C135.121,43.1,132.761,44.946,129.859,44.946Zm-3.753-6.733v2.612c0,1.417,1.719,2.613,3.753,2.613s3.754-1.2,3.754-2.613V38.213Z",
    transform: "translate(-115.585 -36.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117140",
    "data-name": "Path 117140",
    d: "M117.9,44.946c-2.9,0-5.26-1.848-5.26-4.121V37.459a.754.754,0,0,1,.754-.754h9.014a.754.754,0,0,1,.754.754v3.366C123.162,43.1,120.8,44.946,117.9,44.946Zm-3.753-6.733v2.612c0,1.417,1.719,2.613,3.753,2.613s3.754-1.2,3.754-2.613V38.213Z",
    transform: "translate(-112.64 -36.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117141",
    "data-name": "Path 117141",
    d: "M213.662,44.946c-2.9,0-5.261-1.848-5.261-4.121V37.459a.754.754,0,0,1,.754-.754h9.014a.754.754,0,0,1,.754.754v3.366C218.923,43.1,216.563,44.946,213.662,44.946Zm-3.754-6.733v2.612c0,1.417,1.719,2.613,3.754,2.613s3.753-1.2,3.753-2.613V38.213Z",
    transform: "translate(-136.221 -36.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117142",
    "data-name": "Path 117142",
    d: "M201.659,44.946c-2.9,0-5.262-1.848-5.262-4.121V37.459a.754.754,0,0,1,.754-.754h9.015a.754.754,0,0,1,.754.754v3.366C206.919,43.1,204.56,44.946,201.659,44.946ZM197.9,38.213v2.612c0,1.417,1.72,2.613,3.754,2.613s3.753-1.2,3.753-2.613V38.213Z",
    transform: "translate(-133.265 -36.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117143",
    "data-name": "Path 117143",
    d: "M189.7,44.946c-2.9,0-5.261-1.848-5.261-4.121V37.459a.754.754,0,0,1,.754-.754h9.014a.754.754,0,0,1,.754.754v3.366C194.96,43.1,192.6,44.946,189.7,44.946Zm-3.754-6.733v2.612c0,1.417,1.719,2.613,3.754,2.613s3.753-1.2,3.753-2.613V38.213Z",
    transform: "translate(-130.32 -36.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117144",
    "data-name": "Path 117144",
    d: "M177.74,44.946c-2.9,0-5.261-1.848-5.261-4.121V37.459a.754.754,0,0,1,.754-.754h9.014a.754.754,0,0,1,.754.754v3.366C183,43.1,180.641,44.946,177.74,44.946Zm-3.754-6.733v2.612c0,1.417,1.719,2.613,3.754,2.613s3.753-1.2,3.753-2.613V38.213Z",
    transform: "translate(-127.375 -36.705)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_117145",
    "data-name": "Path 117145",
    d: "M188.027,18.6H126.321a.754.754,0,0,1-.754-.754V9.543a4.62,4.62,0,0,1,4.615-4.614h53.984a4.62,4.62,0,0,1,4.615,4.614V17.85A.754.754,0,0,1,188.027,18.6ZM127.075,17.1h60.2V9.543a3.111,3.111,0,0,0-3.108-3.107H130.182a3.111,3.111,0,0,0-3.108,3.107Z",
    transform: "translate(-114.182 -4.929)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(17.449 3.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117146",
    "data-name": "Path 117146",
    d: "M139.385,14.1a1.729,1.729,0,0,1-.153.669,2.4,2.4,0,0,1-.479.706,2.44,2.44,0,0,1-.835.563,2.99,2.99,0,0,1-1.183.216,4.131,4.131,0,0,1-.932-.1,2.492,2.492,0,0,1-1.391-.843,3.184,3.184,0,0,1-.437-.682,3.6,3.6,0,0,1-.272-.806,4.4,4.4,0,0,1-.09-.91,4.04,4.04,0,0,1,.228-1.4,2.984,2.984,0,0,1,.651-1.058,2.839,2.839,0,0,1,.994-.669,3.219,3.219,0,0,1,1.214-.229,3.028,3.028,0,0,1,1.4.314,2.532,2.532,0,0,1,.941.775,1.525,1.525,0,0,1,.327.872.566.566,0,0,1-.159.4.5.5,0,0,1-.384.173.534.534,0,0,1-.378-.119,1.67,1.67,0,0,1-.28-.411,1.974,1.974,0,0,0-.6-.72,1.473,1.473,0,0,0-.855-.239,1.549,1.549,0,0,0-1.287.614,2.778,2.778,0,0,0-.479,1.744,3.246,3.246,0,0,0,.212,1.257,1.582,1.582,0,0,0,.6.748,1.657,1.657,0,0,0,.91.248,1.6,1.6,0,0,0,.957-.28,1.7,1.7,0,0,0,.589-.824,1.4,1.4,0,0,1,.207-.418.469.469,0,0,1,.4-.161.555.555,0,0,1,.4.164A.545.545,0,0,1,139.385,14.1Z",
    transform: "translate(-133.612 -9.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117147",
    "data-name": "Path 117147",
    d: "M145.585,9.559a3.45,3.45,0,0,1,1.729.409,2.645,2.645,0,0,1,1.093,1.162,3.949,3.949,0,0,1,.372,1.768,4.322,4.322,0,0,1-.2,1.365,2.952,2.952,0,0,1-.61,1.064,2.661,2.661,0,0,1-1,.689,3.937,3.937,0,0,1-2.716-.007,2.688,2.688,0,0,1-1-.691,2.947,2.947,0,0,1-.607-1.073,4.32,4.32,0,0,1-.205-1.355,4.176,4.176,0,0,1,.214-1.37,2.936,2.936,0,0,1,.62-1.06,2.681,2.681,0,0,1,.989-.669A3.566,3.566,0,0,1,145.585,9.559Zm1.864,3.33a3.04,3.04,0,0,0-.23-1.232,1.712,1.712,0,0,0-.656-.788,1.8,1.8,0,0,0-.978-.268,1.772,1.772,0,0,0-.727.148,1.6,1.6,0,0,0-.574.43,2.053,2.053,0,0,0-.38.722,3.266,3.266,0,0,0-.139.987,3.348,3.348,0,0,0,.139,1,2.056,2.056,0,0,0,.393.739,1.654,1.654,0,0,0,.583.439,1.739,1.739,0,0,0,2.319-.883A3,3,0,0,0,147.449,12.889Z",
    transform: "translate(-135.785 -9.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117148",
    "data-name": "Path 117148",
    d: "M152.409,15.455v-5.1a.861.861,0,0,1,.181-.6.606.606,0,0,1,.469-.2.623.623,0,0,1,.479.2.853.853,0,0,1,.183.6v5.1a.861.861,0,0,1-.183.6.623.623,0,0,1-.479.2.6.6,0,0,1-.467-.2A.863.863,0,0,1,152.409,15.455Z",
    transform: "translate(-138.241 -9.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117149",
    "data-name": "Path 117149",
    d: "M157.809,10.345l2.522,3.815V10.31a.843.843,0,0,1,.161-.563.543.543,0,0,1,.435-.188.562.562,0,0,1,.446.188.839.839,0,0,1,.164.563V15.4q0,.851-.707.852a.936.936,0,0,1-.318-.051.8.8,0,0,1-.265-.161,1.564,1.564,0,0,1-.23-.259q-.106-.147-.212-.3l-2.46-3.772V15.5a.81.81,0,0,1-.172.561.57.57,0,0,1-.442.19.565.565,0,0,1-.446-.191.824.824,0,0,1-.168-.559v-5a1.4,1.4,0,0,1,.071-.5.707.707,0,0,1,.278-.324.753.753,0,0,1,.42-.126.721.721,0,0,1,.3.057.734.734,0,0,1,.221.155,1.593,1.593,0,0,1,.194.252C157.671,10.126,157.739,10.233,157.809,10.345Z",
    transform: "translate(-139.154 -9.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117150",
    "data-name": "Path 117150",
    d: "M173.058,14.2a1.906,1.906,0,0,1-.3,1.055,2.014,2.014,0,0,1-.886.733,3.323,3.323,0,0,1-1.382.265,3.114,3.114,0,0,1-1.581-.362,2.112,2.112,0,0,1-.718-.7,1.581,1.581,0,0,1-.276-.846.574.574,0,0,1,.587-.579.5.5,0,0,1,.351.133,1.031,1.031,0,0,1,.245.393,2.642,2.642,0,0,0,.268.516,1.082,1.082,0,0,0,.4.342,1.493,1.493,0,0,0,.684.135,1.545,1.545,0,0,0,.947-.271.818.818,0,0,0,.364-.678.716.716,0,0,0-.2-.523,1.262,1.262,0,0,0-.508-.307,8.553,8.553,0,0,0-.833-.225,6.147,6.147,0,0,1-1.168-.382,1.892,1.892,0,0,1-.747-.6,1.548,1.548,0,0,1-.276-.938,1.61,1.61,0,0,1,.292-.95,1.844,1.844,0,0,1,.843-.638,3.46,3.46,0,0,1,1.3-.222,3.21,3.21,0,0,1,1.031.148,2.19,2.19,0,0,1,.722.393,1.642,1.642,0,0,1,.419.515,1.179,1.179,0,0,1,.133.525.623.623,0,0,1-.165.422.53.53,0,0,1-.413.188.472.472,0,0,1-.342-.113,1.488,1.488,0,0,1-.254-.369,1.682,1.682,0,0,0-.424-.572,1.243,1.243,0,0,0-.8-.205,1.375,1.375,0,0,0-.819.223.648.648,0,0,0-.312.537.542.542,0,0,0,.106.335.9.9,0,0,0,.292.243,1.966,1.966,0,0,0,.375.159q.19.058.627.168a9.714,9.714,0,0,1,.991.283,3.018,3.018,0,0,1,.755.375,1.535,1.535,0,0,1,.486.559A1.793,1.793,0,0,1,173.058,14.2Z",
    transform: "translate(-142.059 -9.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117151",
    "data-name": "Path 117151",
    d: "M177.54,10.353v1.855h2.831V10.353a.869.869,0,0,1,.179-.6.6.6,0,0,1,.47-.2.624.624,0,0,1,.479.2.853.853,0,0,1,.183.6v5.1a.854.854,0,0,1-.185.6.625.625,0,0,1-.477.2.6.6,0,0,1-.473-.2.885.885,0,0,1-.176-.6V13.277H177.54v2.178a.855.855,0,0,1-.185.6.625.625,0,0,1-.477.2.6.6,0,0,1-.473-.2.885.885,0,0,1-.176-.6v-5.1a.884.884,0,0,1,.174-.6.6.6,0,0,1,.475-.2.624.624,0,0,1,.479.2A.853.853,0,0,1,177.54,10.353Z",
    transform: "translate(-144.106 -9.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117152",
    "data-name": "Path 117152",
    d: "M188.083,9.559a3.45,3.45,0,0,1,1.729.409,2.644,2.644,0,0,1,1.093,1.162,3.949,3.949,0,0,1,.372,1.768,4.322,4.322,0,0,1-.2,1.365,2.962,2.962,0,0,1-.609,1.064,2.669,2.669,0,0,1-1,.689,3.937,3.937,0,0,1-2.716-.007,2.694,2.694,0,0,1-1-.691,2.946,2.946,0,0,1-.608-1.073,4.32,4.32,0,0,1-.205-1.355,4.175,4.175,0,0,1,.214-1.37,2.934,2.934,0,0,1,.62-1.06,2.681,2.681,0,0,1,.989-.669A3.566,3.566,0,0,1,188.083,9.559Zm1.864,3.33a3.04,3.04,0,0,0-.23-1.232,1.713,1.713,0,0,0-.656-.788,1.8,1.8,0,0,0-.978-.268,1.772,1.772,0,0,0-.727.148,1.6,1.6,0,0,0-.574.43,2.054,2.054,0,0,0-.38.722,3.266,3.266,0,0,0-.139.987,3.348,3.348,0,0,0,.139,1,2.056,2.056,0,0,0,.393.739,1.654,1.654,0,0,0,.583.439,1.738,1.738,0,0,0,2.319-.883A3,3,0,0,0,189.947,12.889Z",
    transform: "translate(-146.25 -9.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117153",
    "data-name": "Path 117153",
    d: "M197.35,13.658h-1.2v1.833a.857.857,0,0,1-.185.6.655.655,0,0,1-.945,0,.855.855,0,0,1-.181-.589V10.508a.816.816,0,0,1,.2-.618.9.9,0,0,1,.631-.185h1.683a4.427,4.427,0,0,1,1.148.115,1.7,1.7,0,0,1,.687.367,1.642,1.642,0,0,1,.439.627,2.2,2.2,0,0,1,.151.834,1.844,1.844,0,0,1-.61,1.5A2.768,2.768,0,0,1,197.35,13.658Zm-.318-2.968h-.883v1.979h.883a2.634,2.634,0,0,0,.775-.1.9.9,0,0,0,.475-.318.946.946,0,0,0,.164-.579.978.978,0,0,0-.252-.7A1.678,1.678,0,0,0,197.032,10.69Z",
    transform: "translate(-148.689 -9.595)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 63.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117154",
    "data-name": "Path 117154",
    d: "M194.939,90.734V93.3H111.97V90.734h82.968m0-1.507H111.97a1.507,1.507,0,0,0-1.508,1.507V93.3a1.508,1.508,0,0,0,1.508,1.507h82.968a1.508,1.508,0,0,0,1.508-1.507V90.734a1.507,1.507,0,0,0-1.508-1.507Z",
    transform: "translate(-110.463 -89.227)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(1.507 65.047)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 82.969,
    height: 2.567,
    fill: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(73.051 59.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117155",
    "data-name": "Path 117155",
    d: "M214.97,85.34v2.567h-6.082V85.34h6.082m0-1.507h-6.082a1.508,1.508,0,0,0-1.507,1.507v2.567a1.508,1.508,0,0,0,1.507,1.508h6.082a1.507,1.507,0,0,0,1.507-1.508V85.34a1.508,1.508,0,0,0-1.507-1.507Z",
    transform: "translate(-207.38 -83.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(1.508 1.508)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 6.082,
    height: 2.567,
    fill: "#909090"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(75.312 55.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117156",
    "data-name": "Path 117156",
    d: "M215.708,79.929V82.5h-3.821V79.929h3.821m0-1.507h-3.821a1.508,1.508,0,0,0-1.508,1.507V82.5A1.508,1.508,0,0,0,211.887,84h3.821a1.507,1.507,0,0,0,1.508-1.508V79.929a1.508,1.508,0,0,0-1.508-1.507Z",
    transform: "translate(-210.38 -78.422)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(1.508 1.508)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 3.821,
    height: 2.567,
    fill: "#cfcfcf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(3.769 59.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117157",
    "data-name": "Path 117157",
    d: "M123.053,85.34v2.567H116.97V85.34h6.082m0-1.507H116.97a1.508,1.508,0,0,0-1.507,1.507v2.567a1.507,1.507,0,0,0,1.507,1.508h6.082a1.508,1.508,0,0,0,1.507-1.508V85.34a1.508,1.508,0,0,0-1.507-1.507Z",
    transform: "translate(-115.463 -83.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(1.507 1.508)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 6.082,
    height: 2.567,
    fill: "#909090"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(3.769 55.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117158",
    "data-name": "Path 117158",
    d: "M120.791,79.929V82.5H116.97V79.929h3.821m0-1.507H116.97a1.508,1.508,0,0,0-1.507,1.507V82.5A1.507,1.507,0,0,0,116.97,84h3.821A1.508,1.508,0,0,0,122.3,82.5V79.929a1.508,1.508,0,0,0-1.507-1.507Z",
    transform: "translate(-115.463 -78.422)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(1.507 1.508)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 3.821,
    height: 2.567,
    fill: "#cfcfcf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(9.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(2.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(0 3.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117159",
    "data-name": "Path 117159",
    d: "M20.512,25.505a.754.754,0,0,1-.754-.754V17.54a.754.754,0,1,1,1.507,0v7.212A.754.754,0,0,1,20.512,25.505Z",
    transform: "translate(-19.758 -9.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117160",
    "data-name": "Path 117160",
    d: "M20.512,12.383a.753.753,0,0,1-.754-.754V8.423a.754.754,0,1,1,1.507,0v3.206A.753.753,0,0,1,20.512,12.383Z",
    transform: "translate(-19.758 -7.669)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(6.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(0 8.379)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 6.458,
    transform: "translate(0.754 0.754)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117161",
    "data-name": "Path 117161",
    d: "M29.512,21.752A.754.754,0,0,1,28.758,21V14.54a.754.754,0,0,1,1.508,0V21A.754.754,0,0,1,29.512,21.752Z",
    transform: "translate(-28.758 -13.786)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y2: 4.714,
    transform: "translate(0.754 0.754)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117162",
    "data-name": "Path 117162",
    d: "M29.512,8.89a.753.753,0,0,1-.754-.754V3.423a.754.754,0,0,1,1.508,0V8.137A.753.753,0,0,1,29.512,8.89Z",
    transform: "translate(-28.758 -2.669)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(13.568 6.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117163",
    "data-name": "Path 117163",
    d: "M38.512,26a.754.754,0,0,1-.754-.754v-5.7a.754.754,0,0,1,1.507,0v5.7A.754.754,0,0,1,38.512,26Z",
    transform: "translate(-37.758 -12.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117164",
    "data-name": "Path 117164",
    d: "M38.512,14.629a.753.753,0,0,1-.754-.754V11.423a.754.754,0,1,1,1.507,0v2.453A.753.753,0,0,1,38.512,14.629Z",
    transform: "translate(-37.758 -10.669)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0 3.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117165",
    "data-name": "Path 117165",
    d: "M20.512,25.505a.754.754,0,0,1-.754-.754V17.54a.754.754,0,1,1,1.507,0v7.212A.754.754,0,0,1,20.512,25.505Z",
    transform: "translate(-19.758 -9.914)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117166",
    "data-name": "Path 117166",
    d: "M20.512,12.383a.753.753,0,0,1-.754-.754V8.423a.754.754,0,1,1,1.507,0v3.206A.753.753,0,0,1,20.512,12.383Z",
    transform: "translate(-19.758 -7.669)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(6.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(0 8.379)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y2: 6.458,
    transform: "translate(0.754 0.754)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117167",
    "data-name": "Path 117167",
    d: "M29.512,21.752A.754.754,0,0,1,28.758,21V14.54a.754.754,0,0,1,1.508,0V21A.754.754,0,0,1,29.512,21.752Z",
    transform: "translate(-28.758 -13.786)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y2: 4.714,
    transform: "translate(0.754 0.754)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117168",
    "data-name": "Path 117168",
    d: "M29.512,8.89a.753.753,0,0,1-.754-.754V3.423a.754.754,0,0,1,1.508,0V8.137A.753.753,0,0,1,29.512,8.89Z",
    transform: "translate(-28.758 -2.669)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(13.568 6.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117169",
    "data-name": "Path 117169",
    d: "M38.512,26a.754.754,0,0,1-.754-.754v-5.7a.754.754,0,0,1,1.507,0v5.7A.754.754,0,0,1,38.512,26Z",
    transform: "translate(-37.758 -12.668)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117170",
    "data-name": "Path 117170",
    d: "M38.512,14.629a.753.753,0,0,1-.754-.754V11.423a.754.754,0,1,1,1.507,0v2.453A.753.753,0,0,1,38.512,14.629Z",
    transform: "translate(-37.758 -10.669)",
    fill: "#231f20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0 13.117)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9980",
    "data-name": "Ellipse 9980",
    cx: 8.243,
    cy: 8.243,
    r: 8.243,
    transform: "translate(1.508 1.508)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9981",
    "data-name": "Ellipse 9981",
    cx: 5.694,
    cy: 5.694,
    r: 5.694,
    transform: "translate(4.057 4.057)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117171",
    "data-name": "Path 117171",
    d: "M26.572,21.578a8.243,8.243,0,1,1-8.244,8.244,8.243,8.243,0,0,1,8.244-8.244m0-1.507a9.751,9.751,0,1,0,9.751,9.751,9.763,9.763,0,0,0-9.751-9.751Z",
    transform: "translate(-16.821 -20.071)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(23.571 29.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(4.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117172",
    "data-name": "Path 117172",
    d: "M54.85,53.907a.753.753,0,0,1-.754-.754V42.173a.754.754,0,1,1,1.508,0V53.153A.754.754,0,0,1,54.85,53.907Z",
    transform: "translate(-54.096 -41.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117173",
    "data-name": "Path 117173",
    d: "M54.85,66.318a.754.754,0,0,1-.754-.754V61.6a.754.754,0,1,1,1.508,0v3.96A.754.754,0,0,1,54.85,66.318Z",
    transform: "translate(-54.096 -46.204)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(0 7.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y1: 9.99,
    transform: "translate(0.754 0.754)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117174",
    "data-name": "Path 117174",
    d: "M48.847,63.348a.754.754,0,0,1-.754-.754V52.6a.754.754,0,1,1,1.507,0v9.99A.754.754,0,0,1,48.847,63.348Z",
    transform: "translate(-48.093 -51.85)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(4.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117175",
    "data-name": "Path 117175",
    d: "M54.85,53.907a.753.753,0,0,1-.754-.754V42.173a.754.754,0,1,1,1.508,0V53.153A.754.754,0,0,1,54.85,53.907Z",
    transform: "translate(-54.096 -41.419)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117176",
    "data-name": "Path 117176",
    d: "M54.85,66.318a.754.754,0,0,1-.754-.754V61.6a.754.754,0,1,1,1.508,0v3.96A.754.754,0,0,1,54.85,66.318Z",
    transform: "translate(-54.096 -46.204)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(0 7.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 9.99,
    transform: "translate(0.754 0.754)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117177",
    "data-name": "Path 117177",
    d: "M48.847,63.348a.754.754,0,0,1-.754-.754V52.6a.754.754,0,1,1,1.507,0v9.99A.754.754,0,0,1,48.847,63.348Z",
    transform: "translate(-48.093 -51.85)",
    fill: "#231f20"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(19.954 46.144)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9982",
    "data-name": "Ellipse 9982",
    cx: 5.126,
    cy: 5.126,
    r: 5.126,
    transform: "translate(1.507 1.508)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9983",
    "data-name": "Ellipse 9983",
    cx: 3.54,
    cy: 3.54,
    r: 3.54,
    transform: "translate(3.093 3.093)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117178",
    "data-name": "Path 117178",
    d: "M49.927,65.4A5.126,5.126,0,1,1,44.8,70.521,5.126,5.126,0,0,1,49.927,65.4m0-1.507a6.633,6.633,0,1,0,6.634,6.633,6.641,6.641,0,0,0-6.634-6.633Z",
    transform: "translate(-43.294 -63.888)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(41.824 5.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(10.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117179",
    "data-name": "Path 117179",
    d: "M86.778,32.179a.754.754,0,0,1-.754-.754v-9.1a.754.754,0,1,1,1.507,0v9.1A.754.754,0,0,1,86.778,32.179Z",
    transform: "translate(-86.024 -13.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117180",
    "data-name": "Path 117180",
    d: "M86.778,44.729a.754.754,0,0,1-.754-.754V39.261a.754.754,0,1,1,1.507,0v4.715A.754.754,0,0,1,86.778,44.729Z",
    transform: "translate(-86.024 -17.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117181",
    "data-name": "Path 117181",
    d: "M86.778,16.831a.754.754,0,0,1-.754-.754V11.364a.754.754,0,1,1,1.507,0v4.714A.753.753,0,0,1,86.778,16.831Z",
    transform: "translate(-86.024 -10.61)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(5.169 7.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y1: 3.443,
    transform: "translate(0.753 0.754)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117182",
    "data-name": "Path 117182",
    d: "M79.921,25.028a.754.754,0,0,1-.754-.754V20.831a.754.754,0,1,1,1.507,0v3.443A.754.754,0,0,1,79.921,25.028Z",
    transform: "translate(-79.167 -20.077)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 7.108)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 13.005,
    transform: "translate(0.753 0.754)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117183",
    "data-name": "Path 117183",
    d: "M79.921,44.02a.754.754,0,0,1-.754-.754V30.261a.754.754,0,1,1,1.507,0V43.267A.754.754,0,0,1,79.921,44.02Z",
    transform: "translate(-79.167 -29.507)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 8.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117184",
    "data-name": "Path 117184",
    d: "M73.063,28.559a.754.754,0,0,1-.754-.754V22.928a.754.754,0,0,1,1.508,0v4.878A.754.754,0,0,1,73.063,28.559Z",
    transform: "translate(-72.309 -22.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117185",
    "data-name": "Path 117185",
    d: "M73.063,44.287a.754.754,0,0,1-.754-.754V34.261a.754.754,0,1,1,1.508,0v9.273A.754.754,0,0,1,73.063,44.287Z",
    transform: "translate(-72.309 -24.965)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(10.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117186",
    "data-name": "Path 117186",
    d: "M86.778,32.179a.754.754,0,0,1-.754-.754v-9.1a.754.754,0,1,1,1.507,0v9.1A.754.754,0,0,1,86.778,32.179Z",
    transform: "translate(-86.024 -13.309)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117187",
    "data-name": "Path 117187",
    d: "M86.778,44.729a.754.754,0,0,1-.754-.754V39.261a.754.754,0,1,1,1.507,0v4.715A.754.754,0,0,1,86.778,44.729Z",
    transform: "translate(-86.024 -17.48)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117188",
    "data-name": "Path 117188",
    d: "M86.778,16.831a.754.754,0,0,1-.754-.754V11.364a.754.754,0,1,1,1.507,0v4.714A.753.753,0,0,1,86.778,16.831Z",
    transform: "translate(-86.024 -10.61)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(5.169 7.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y1: 3.443,
    transform: "translate(0.753 0.754)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117189",
    "data-name": "Path 117189",
    d: "M79.921,25.028a.754.754,0,0,1-.754-.754V20.831a.754.754,0,1,1,1.507,0v3.443A.754.754,0,0,1,79.921,25.028Z",
    transform: "translate(-79.167 -20.077)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0 7.108)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y1: 13.005,
    transform: "translate(0.753 0.754)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117190",
    "data-name": "Path 117190",
    d: "M79.921,44.02a.754.754,0,0,1-.754-.754V30.261a.754.754,0,1,1,1.507,0V43.267A.754.754,0,0,1,79.921,44.02Z",
    transform: "translate(-79.167 -29.507)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(0 8.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117191",
    "data-name": "Path 117191",
    d: "M73.063,28.559a.754.754,0,0,1-.754-.754V22.928a.754.754,0,0,1,1.508,0v4.878A.754.754,0,0,1,73.063,28.559Z",
    transform: "translate(-72.309 -22.174)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117192",
    "data-name": "Path 117192",
    d: "M73.063,44.287a.754.754,0,0,1-.754-.754V34.261a.754.754,0,1,1,1.508,0v9.273A.754.754,0,0,1,73.063,44.287Z",
    transform: "translate(-72.309 -24.965)",
    fill: "#231f20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(39.98 27.861)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9984",
    "data-name": "Ellipse 9984",
    cx: 6.259,
    cy: 6.259,
    r: 6.259,
    transform: "translate(1.507 1.507)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9985",
    "data-name": "Ellipse 9985",
    cx: 4.323,
    cy: 4.323,
    r: 4.323,
    transform: "translate(3.443 3.443)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117193",
    "data-name": "Path 117193",
    d: "M77.63,41.139A6.259,6.259,0,1,1,71.37,47.4a6.259,6.259,0,0,1,6.259-6.259m0-1.507A7.766,7.766,0,1,0,85.4,47.4a7.775,7.775,0,0,0-7.766-7.767Z",
    transform: "translate(-69.863 -39.632)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(165.988 0.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(2.379 20.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0 4.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117194",
    "data-name": "Path 117194",
    d: "M240.947,58.159a.754.754,0,0,1-.754-.754V46.425a.754.754,0,0,1,1.508,0V57.405A.753.753,0,0,1,240.947,58.159Z",
    transform: "translate(-240.193 -38.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117195",
    "data-name": "Path 117195",
    d: "M240.947,41.023a.754.754,0,0,1-.754-.754v-3.96a.754.754,0,0,1,1.508,0v3.96A.754.754,0,0,1,240.947,41.023Z",
    transform: "translate(-240.193 -35.555)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(6.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(0 16.671)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y2: 3.443,
    transform: "translate(0.754 0.753)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117196",
    "data-name": "Path 117196",
    d: "M249.947,56.622a.754.754,0,0,1-.754-.754V52.426a.754.754,0,1,1,1.508,0v3.442A.753.753,0,0,1,249.947,56.622Z",
    transform: "translate(-249.193 -51.672)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y2: 13.005,
    transform: "translate(0.754 0.753)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117197",
    "data-name": "Path 117197",
    d: "M249.947,44.068a.754.754,0,0,1-.754-.754V30.309a.754.754,0,1,1,1.508,0V43.314A.754.754,0,0,1,249.947,44.068Z",
    transform: "translate(-249.193 -29.555)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(13.568 6.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117198",
    "data-name": "Path 117198",
    d: "M258.947,58.652a.754.754,0,0,1-.754-.754V48.425a.754.754,0,1,1,1.507,0V57.9A.753.753,0,0,1,258.947,58.652Z",
    transform: "translate(-258.193 -40.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117199",
    "data-name": "Path 117199",
    d: "M258.947,43.023a.754.754,0,0,1-.754-.754v-3.96a.754.754,0,1,1,1.507,0v3.96A.754.754,0,0,1,258.947,43.023Z",
    transform: "translate(-258.193 -37.555)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(0 4.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117200",
    "data-name": "Path 117200",
    d: "M240.947,58.159a.754.754,0,0,1-.754-.754V46.425a.754.754,0,0,1,1.508,0V57.405A.753.753,0,0,1,240.947,58.159Z",
    transform: "translate(-240.193 -38.046)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117201",
    "data-name": "Path 117201",
    d: "M240.947,41.023a.754.754,0,0,1-.754-.754v-3.96a.754.754,0,0,1,1.508,0v3.96A.754.754,0,0,1,240.947,41.023Z",
    transform: "translate(-240.193 -35.555)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(6.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(0 16.671)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y2: 3.443,
    transform: "translate(0.754 0.753)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117202",
    "data-name": "Path 117202",
    d: "M249.947,56.622a.754.754,0,0,1-.754-.754V52.426a.754.754,0,1,1,1.508,0v3.442A.753.753,0,0,1,249.947,56.622Z",
    transform: "translate(-249.193 -51.672)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    y2: 13.005,
    transform: "translate(0.754 0.753)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117203",
    "data-name": "Path 117203",
    d: "M249.947,44.068a.754.754,0,0,1-.754-.754V30.309a.754.754,0,1,1,1.508,0V43.314A.754.754,0,0,1,249.947,44.068Z",
    transform: "translate(-249.193 -29.555)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(13.568 6.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117204",
    "data-name": "Path 117204",
    d: "M258.947,58.652a.754.754,0,0,1-.754-.754V48.425a.754.754,0,1,1,1.507,0V57.9A.753.753,0,0,1,258.947,58.652Z",
    transform: "translate(-258.193 -40.046)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117205",
    "data-name": "Path 117205",
    d: "M258.947,43.023a.754.754,0,0,1-.754-.754v-3.96a.754.754,0,1,1,1.507,0v3.96A.754.754,0,0,1,258.947,43.023Z",
    transform: "translate(-258.193 -37.555)",
    fill: "#231f20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(25.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117206",
    "data-name": "Path 117206",
    d: "M271.4,25.321a.754.754,0,0,1-.754-.754V13.587a.754.754,0,1,1,1.507,0V24.567A.754.754,0,0,1,271.4,25.321Z",
    transform: "translate(-270.644 -5.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117207",
    "data-name": "Path 117207",
    d: "M271.4,8.184a.754.754,0,0,1-.754-.754V3.47a.754.754,0,1,1,1.507,0V7.43A.754.754,0,0,1,271.4,8.184Z",
    transform: "translate(-270.644 -2.716)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(4.524 2.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y2: 6.975,
    transform: "translate(0.754 0.754)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117208",
    "data-name": "Path 117208",
    d: "M277.4,14.2a.754.754,0,0,1-.754-.754V6.47a.754.754,0,0,1,1.508,0v6.975A.754.754,0,0,1,277.4,14.2Z",
    transform: "translate(-276.646 -5.716)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117209",
    "data-name": "Path 117209",
    d: "M271.4,25.321a.754.754,0,0,1-.754-.754V13.587a.754.754,0,1,1,1.507,0V24.567A.754.754,0,0,1,271.4,25.321Z",
    transform: "translate(-270.644 -5.207)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117210",
    "data-name": "Path 117210",
    d: "M271.4,8.184a.754.754,0,0,1-.754-.754V3.47a.754.754,0,1,1,1.507,0V7.43A.754.754,0,0,1,271.4,8.184Z",
    transform: "translate(-270.644 -2.716)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(4.524 2.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y2: 6.975,
    transform: "translate(0.754 0.754)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117211",
    "data-name": "Path 117211",
    d: "M277.4,14.2a.754.754,0,0,1-.754-.754V6.47a.754.754,0,0,1,1.508,0v6.975A.754.754,0,0,1,277.4,14.2Z",
    transform: "translate(-276.646 -5.716)",
    fill: "#231f20"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(0 39.873)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9986",
    "data-name": "Ellipse 9986",
    cx: 8.243,
    cy: 8.243,
    r: 8.243,
    transform: "translate(1.508 1.508)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9987",
    "data-name": "Ellipse 9987",
    cx: 5.694,
    cy: 5.694,
    r: 5.694,
    transform: "translate(4.057 4.057)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117212",
    "data-name": "Path 117212",
    d: "M246.788,57.123a8.243,8.243,0,1,1-8.244,8.243,8.243,8.243,0,0,1,8.244-8.243m0-1.508a9.751,9.751,0,1,0,9.751,9.751,9.762,9.762,0,0,0-9.751-9.751Z",
    transform: "translate(-237.037 -55.616)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(21.713 13.081)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9988",
    "data-name": "Ellipse 9988",
    cx: 5.126,
    cy: 5.126,
    r: 5.126,
    transform: "translate(1.508 1.508)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9989",
    "data-name": "Ellipse 9989",
    cx: 3.54,
    cy: 3.54,
    r: 3.54,
    transform: "translate(3.093 3.093)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117213",
    "data-name": "Path 117213",
    d: "M272.478,21.578a5.126,5.126,0,1,1-5.126,5.126,5.126,5.126,0,0,1,5.126-5.126m0-1.507a6.633,6.633,0,1,0,6.633,6.634,6.641,6.641,0,0,0-6.633-6.634Z",
    transform: "translate(-265.844 -20.071)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(47.471 10.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(10.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117214",
    "data-name": "Path 117214",
    d: "M314.487,31.826a.754.754,0,0,1-.754-.754V17.831a.754.754,0,1,1,1.507,0V31.073A.754.754,0,0,1,314.487,31.826Z",
    transform: "translate(-313.733 -17.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117215",
    "data-name": "Path 117215",
    d: "M314.487,45.729a.754.754,0,0,1-.754-.754V40.262a.754.754,0,1,1,1.507,0v4.714A.754.754,0,0,1,314.487,45.729Z",
    transform: "translate(-313.733 -22.601)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(5.169 3.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y1: 3.443,
    transform: "translate(0.754 0.754)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117216",
    "data-name": "Path 117216",
    d: "M307.629,26.028a.754.754,0,0,1-.754-.754V21.831a.754.754,0,1,1,1.507,0v3.443A.754.754,0,0,1,307.629,26.028Z",
    transform: "translate(-306.875 -21.077)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(0 7.109)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y1: 13.005,
    transform: "translate(0.754 0.753)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117217",
    "data-name": "Path 117217",
    d: "M307.629,45.021a.754.754,0,0,1-.754-.754V31.262a.754.754,0,1,1,1.507,0V44.267A.754.754,0,0,1,307.629,45.021Z",
    transform: "translate(-306.875 -30.508)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(0 4.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117218",
    "data-name": "Path 117218",
    d: "M300.771,29.559a.754.754,0,0,1-.754-.754V23.929a.754.754,0,0,1,1.508,0v4.877A.754.754,0,0,1,300.771,29.559Z",
    transform: "translate(-300.017 -23.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117219",
    "data-name": "Path 117219",
    d: "M300.771,45.287a.754.754,0,0,1-.754-.754V35.262a.754.754,0,1,1,1.508,0v9.272A.754.754,0,0,1,300.771,45.287Z",
    transform: "translate(-300.017 -25.966)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(10.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117220",
    "data-name": "Path 117220",
    d: "M314.487,31.826a.754.754,0,0,1-.754-.754V17.831a.754.754,0,1,1,1.507,0V31.073A.754.754,0,0,1,314.487,31.826Z",
    transform: "translate(-313.733 -17.077)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117221",
    "data-name": "Path 117221",
    d: "M314.487,45.729a.754.754,0,0,1-.754-.754V40.262a.754.754,0,1,1,1.507,0v4.714A.754.754,0,0,1,314.487,45.729Z",
    transform: "translate(-313.733 -22.601)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(5.169 3.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y1: 3.443,
    transform: "translate(0.754 0.754)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117222",
    "data-name": "Path 117222",
    d: "M307.629,26.028a.754.754,0,0,1-.754-.754V21.831a.754.754,0,1,1,1.507,0v3.443A.754.754,0,0,1,307.629,26.028Z",
    transform: "translate(-306.875 -21.077)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(0 7.109)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    y1: 13.005,
    transform: "translate(0.754 0.753)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117223",
    "data-name": "Path 117223",
    d: "M307.629,45.021a.754.754,0,0,1-.754-.754V31.262a.754.754,0,1,1,1.507,0V44.267A.754.754,0,0,1,307.629,45.021Z",
    transform: "translate(-306.875 -30.508)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(0 4.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117224",
    "data-name": "Path 117224",
    d: "M300.771,29.559a.754.754,0,0,1-.754-.754V23.929a.754.754,0,0,1,1.508,0v4.877A.754.754,0,0,1,300.771,29.559Z",
    transform: "translate(-300.017 -23.175)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117225",
    "data-name": "Path 117225",
    d: "M300.771,45.287a.754.754,0,0,1-.754-.754V35.262a.754.754,0,1,1,1.508,0v9.272A.754.754,0,0,1,300.771,45.287Z",
    transform: "translate(-300.017 -25.966)",
    fill: "#231f20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(45.628 29.099)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9990",
    "data-name": "Ellipse 9990",
    cx: 6.259,
    cy: 6.259,
    r: 6.259,
    transform: "translate(1.508 1.507)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9991",
    "data-name": "Ellipse 9991",
    cx: 4.323,
    cy: 4.323,
    r: 4.323,
    transform: "translate(3.443 3.443)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117226",
    "data-name": "Path 117226",
    d: "M305.338,42.828a6.259,6.259,0,1,1-6.259,6.259,6.259,6.259,0,0,1,6.259-6.259m0-1.508a7.766,7.766,0,1,0,7.767,7.767,7.775,7.775,0,0,0-7.767-7.767Z",
    transform: "translate(-297.571 -41.321)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(94.238 39.922)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 26.131,
    height: 19.3,
    transform: "translate(29.397 0.754)",
    fill: "#475971"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 19.598,
    height: 27.889,
    transform: "translate(2.262 0.754)",
    fill: "#475971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117227",
    "data-name": "Path 117227",
    d: "M152,85.029H132.4a.754.754,0,0,1-.754-.754V56.387a.754.754,0,0,1,.754-.754H152a.753.753,0,0,1,.754.754V84.276A.753.753,0,0,1,152,85.029Zm-18.844-1.507h18.09V57.14h-18.09Z",
    transform: "translate(-130.138 -55.633)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 22.613,
    height: 3.015,
    transform: "translate(0.754 28.642)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117228",
    "data-name": "Path 117228",
    d: "M153.012,97.156H130.4a.754.754,0,0,1-.754-.754V93.387a.754.754,0,0,1,.754-.754h22.613a.753.753,0,0,1,.754.754V96.4A.753.753,0,0,1,153.012,97.156Zm-21.859-1.508h21.1V94.141h-21.1Z",
    transform: "translate(-129.646 -64.744)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(4.986 3.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 12.642,
    height: 20.351,
    transform: "translate(0.754 0.754)",
    fill: "#bad3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117229",
    "data-name": "Path 117229",
    d: "M149.657,61.387V81.738H137.015V61.387h12.642m.754-.754H136.261V82.492H150.41V60.633Z",
    transform: "translate(-136.261 -60.633)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(0.754 0.754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 12.642,
    height: 20.351,
    fill: "#d2e4f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117230",
    "data-name": "Path 117230",
    d: "M149.9,82.637H137.261L149.9,64.284Z",
    transform: "translate(-136.507 -61.532)",
    fill: "#bad3f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117231",
    "data-name": "Path 117231",
    d: "M153.073,70.771v5.451h-2.184V70.771h2.184m0-.754h-2.184a.754.754,0,0,0-.754.754v5.451a.754.754,0,0,0,.754.754h2.184a.754.754,0,0,0,.754-.754V70.771a.754.754,0,0,0-.754-.754Z",
    transform: "translate(-134.691 -59.175)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 2.185,
    height: 5.452,
    transform: "translate(16.197 11.595)",
    fill: "#909090"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117232",
    "data-name": "Path 117232",
    d: "M194.531,76.44H168.4a.754.754,0,0,1-.754-.754v-19.3a.754.754,0,0,1,.754-.754h26.132a.753.753,0,0,1,.754.754v19.3A.753.753,0,0,1,194.531,76.44Zm-25.378-1.507h24.624V57.14H169.153Z",
    transform: "translate(-139.003 -55.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117233",
    "data-name": "Path 117233",
    d: "M192.5,60.387V73.657H172.4V60.387h20.1m.754-.754H171.647V74.411h21.608V59.633Z",
    transform: "translate(-139.989 -56.618)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 20.101,
    height: 13.27,
    transform: "translate(32.412 3.769)",
    fill: "#d2e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117234",
    "data-name": "Path 117234",
    d: "M192.748,73.9h-20.1l20.1-13.27Z",
    transform: "translate(-140.235 -56.864)",
    fill: "#bad3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 27.696,
    height: 3.015,
    transform: "translate(28.615 20.054)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117235",
    "data-name": "Path 117235",
    d: "M195.059,85.76h-27.7a.754.754,0,0,1-.754-.754V81.992a.754.754,0,0,1,.754-.754h27.7a.754.754,0,0,1,.754.754v3.015A.754.754,0,0,1,195.059,85.76Zm-26.943-1.507h26.189V82.745H168.116Z",
    transform: "translate(-138.748 -61.938)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(35.349 6.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 12.721,
    height: 7.081,
    rx: 1.57,
    transform: "translate(0.754 0.753)",
    fill: "#dc6127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117236",
    "data-name": "Path 117236",
    d: "M179.06,71.825h10.354a1.184,1.184,0,0,0,1.183-1.184V65.928a1.18,1.18,0,0,0-1.022-1.168L178.9,71.808A1.147,1.147,0,0,0,179.06,71.825Z",
    transform: "translate(-177.123 -63.99)",
    fill: "#c2470d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(1.946 2.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117237",
    "data-name": "Path 117237",
    d: "M180.429,66.806a1.1,1.1,0,0,1,.715.242,1.468,1.468,0,0,1,.452.687,3.221,3.221,0,0,1,.154,1.048,3.609,3.609,0,0,1-.084.808,2.034,2.034,0,0,1-.252.63,1.2,1.2,0,0,1-.413.409,1.111,1.111,0,0,1-.562.141,1.092,1.092,0,0,1-.563-.145,1.2,1.2,0,0,1-.415-.409,2.01,2.01,0,0,1-.252-.635,3.6,3.6,0,0,1-.085-.8,3.445,3.445,0,0,1,.089-.811,2,2,0,0,1,.257-.628,1.177,1.177,0,0,1,.409-.4A1.086,1.086,0,0,1,180.429,66.806Zm.771,1.972a2.491,2.491,0,0,0-.1-.73,1.012,1.012,0,0,0-.271-.467.588.588,0,0,0-.4-.158.548.548,0,0,0-.3.088.735.735,0,0,0-.238.255,1.456,1.456,0,0,0-.157.427,2.715,2.715,0,0,0-.058.585,2.778,2.778,0,0,0,.058.591,1.438,1.438,0,0,0,.163.438.766.766,0,0,0,.241.261.547.547,0,0,0,.3.086.575.575,0,0,0,.383-.149,1,1,0,0,0,.278-.46A2.471,2.471,0,0,0,181.2,68.778Z",
    transform: "translate(-179.125 -66.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117238",
    "data-name": "Path 117238",
    d: "M184.265,69.233h-.5v1.085a.659.659,0,0,1-.077.353.224.224,0,0,1-.194.121.227.227,0,0,1-.2-.119.657.657,0,0,1-.075-.349V67.368a.623.623,0,0,1,.082-.366.305.305,0,0,1,.261-.11h.7a1.293,1.293,0,0,1,.476.069.672.672,0,0,1,.284.217,1.053,1.053,0,0,1,.182.371,1.819,1.819,0,0,1,.062.494,1.356,1.356,0,0,1-.252.888A.925.925,0,0,1,184.265,69.233Zm-.132-1.758h-.366v1.172h.366a.787.787,0,0,0,.321-.058.4.4,0,0,0,.2-.188.887.887,0,0,0-.037-.755A.55.55,0,0,0,184.133,67.475Z",
    transform: "translate(-180.135 -66.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117239",
    "data-name": "Path 117239",
    d: "M188.3,67.491h-1.223v.941h1.126a.218.218,0,0,1,.185.08.337.337,0,0,1,.062.21.354.354,0,0,1-.06.213.216.216,0,0,1-.187.082h-1.126v1.091h1.266a.226.226,0,0,1,.192.085.36.36,0,0,1,.065.226.351.351,0,0,1-.065.221.224.224,0,0,1-.192.085H186.87a.288.288,0,0,1-.255-.112.652.652,0,0,1-.078-.363V67.368a.892.892,0,0,1,.035-.274.281.281,0,0,1,.109-.154.339.339,0,0,1,.189-.049H188.3a.228.228,0,0,1,.193.083.347.347,0,0,1,.063.216.355.355,0,0,1-.063.219A.229.229,0,0,1,188.3,67.491Z",
    transform: "translate(-180.95 -66.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117240",
    "data-name": "Path 117240",
    d: "M190.561,67.271l1.043,2.26V67.25a.66.66,0,0,1,.067-.333.2.2,0,0,1,.18-.111.207.207,0,0,1,.185.111.651.651,0,0,1,.068.333v3.016c0,.337-.1.5-.292.5a.281.281,0,0,1-.132-.03.337.337,0,0,1-.109-.1.844.844,0,0,1-.1-.153c-.029-.058-.058-.118-.087-.179l-1.018-2.234v2.247a.63.63,0,0,1-.072.332.211.211,0,0,1-.182.112.208.208,0,0,1-.185-.114.646.646,0,0,1-.069-.331V67.368a1.215,1.215,0,0,1,.029-.3A.42.42,0,0,1,190,66.88a.254.254,0,0,1,.174-.074.225.225,0,0,1,.125.034.328.328,0,0,1,.091.091.947.947,0,0,1,.081.149Z",
    transform: "translate(-181.769 -66.806)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117241",
    "data-name": "Path 117241",
    d: "M188.834,64.493a1.183,1.183,0,0,1,1.183,1.183v4.713a1.184,1.184,0,0,1-1.183,1.184H178.48a1.184,1.184,0,0,1-1.183-1.184V65.676a1.183,1.183,0,0,1,1.183-1.183h10.354m0-.754H178.48a1.939,1.939,0,0,0-1.937,1.937v4.713a1.94,1.94,0,0,0,1.937,1.938h10.354a1.94,1.94,0,0,0,1.937-1.938V65.676a1.939,1.939,0,0,0-1.937-1.937Z",
    transform: "translate(-176.543 -63.739)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllCoinshop);
export default __webpack_public_path__ + "static/media/ill-coinshop.4866c2dc9f7ede45fef67743f5399b2a.svg";
export { ForwardRef as ReactComponent };